import React, { Suspense } from 'react';
import Spinner from '../Spinner/Spinner';

// Loading fallback component
const LoadingFallback = () => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '200px',
      width: '100%',
    }}
  >
    <Spinner />
  </div>
);

// LazyLoader component for wrapping lazy-loaded components
const LazyLoader = ({ children, fallback = <LoadingFallback /> }) => (
  <Suspense fallback={fallback}>{children}</Suspense>
);

export default LazyLoader;
